import { IconButton, Tooltip } from '@mui/material';
import { RemoveFromCollectionIcon } from '../RemoveFromCollectionIcon/RemoveFromCollectionIcon';

export const RemoveFromCollectionIconButton = () => {
  return (
    <Tooltip title="Remove from this collection">
      <IconButton>
        <RemoveFromCollectionIcon color="primary" />
      </IconButton>
    </Tooltip>
  );
};
